import { Select } from 'antd';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { TableCellEntityMode } from 'entities/TableCell';
import { TableSelectController } from 'stores/common';
import { translateApiValue } from 'utils/translateApiValue';

import { TableControllerProps } from '../types';

import { Indicator } from './Indicator';
import s from './SelectController.module.scss';

/**
 * Контроллер селект для отображения в ячейке
 */
const SelectController: React.FC<
  TableControllerProps<TableSelectController>
> = ({ record, className, params }) => {
  const { t } = useTranslation();
  const handleChange = React.useCallback(
    (value: string) => {
      record.setValue(value);
    },
    [record]
  );

  const controllerDisabled = params?.mode === TableCellEntityMode.disabled;

  return (
    <Select
      className={cn(s.selectController, className)}
      value={record.controllerValue.value?.value}
      placeholder={t('table.notSelected') as string}
      onChange={handleChange}
      disabled={controllerDisabled}
    >
      {record.controllerValue.options.map((item) => (
        <Select.Option key={item.id} value={item.value}>
          <div className={s.selectController__item}>
            {item.indicator && <Indicator color={item.indicator.hex} />}
            {translateApiValue(item.value)}
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default observer(SelectController);
